import {
    canBatchFeature,
    canManageArticles,
    canManageRules,
    canManageSatisfaction,
    canManageSurveys,
    canManageTasks,
    canManageUsers,
    canParticipateConversations,
    canViewActivity,
    canViewConversations,
    canViewFeedbackBoard,
    canViewReports,
    isCandidateCommsEnabled, isLookerReportsEnabled,
    isPatientsEnabled
} from "../shared/access";

export const createSubNavConfig = (history, user,setSelectedItemId,selectedItemId) => {
    return {
        isEnabled: true,
        selectedItemId: selectedItemId,
        items: [
            ...(canViewConversations() || canParticipateConversations() ? [{
                title: "Conversations",
                id: "Conversations",
                clickable: {
                    type: "anchor",
                    anchorHref: "/conversations",
                    anchorTarget: "_self",
                    onClick: (e) => {
                        e.preventDefault();
                        setSelectedItemId("Conversations");
                        history.push('/conversations');
                        return {
                            preventOverlayClose: false
                        };
                    },
                },
                items: []
            }] : []),
            ...(canManageUsers() ? [{
                title: "Contacts",
                id: "Contacts",
                clickable: {
                    type: "anchor",
                    anchorHref: "/clients",
                    anchorTarget: "_self",
                    onClick: (e) => {
                        e.preventDefault();
                        setSelectedItemId("Contacts");
                        history.push('/clients');
                        return {
                            preventOverlayClose: false
                        };
                    },
                },
                items: []
            }] : []),
            ...(canViewActivity() ? [{
                title: "Activity",
                id: "Activity",
                clickable: {
                    type: "anchor",
                    anchorHref: "/activity",
                    anchorTarget: "_self",
                    onClick: (e) => {
                        e.preventDefault();
                        setSelectedItemId("Activity");
                        history.push('/activity');
                        return {
                            preventOverlayClose: false
                        };
                    },
                },
                items: []
            }] : []),
            ...(canManageTasks() ? [{
                title: "Tasks",
                id: "Tasks",
                clickable: {
                    type: "anchor",
                    anchorHref: "/tasks",
                    anchorTarget: "_self",
                    onClick: (e) => {
                        e.preventDefault();
                        setSelectedItemId("Tasks");
                        history.push('/tasks');
                        return {
                            preventOverlayClose: false
                        };
                    },
                },
                items: []
            }] : []),
            ...(canViewFeedbackBoard() ? [{
                title: "Feedback",
                id: "Feedback",
                clickable: {
                    type: "anchor",
                    anchorHref: "/positivity",
                    anchorTarget: "_self",
                    onClick: (e) => {
                        e.preventDefault();
                        setSelectedItemId("Feedback");
                        history.push('/positivity');
                        return {
                            preventOverlayClose: false
                        };
                    },
                },
                items: []
            }] : []),
            ...(isCandidateCommsEnabled() ? [{
                title: "Candidates",
                id: "Candidates",
                clickable: {
                    type: "anchor",
                    anchorHref: "/candidates",
                    anchorTarget: "_self",
                    onClick: (e) => {
                        e.preventDefault();
                        setSelectedItemId("Candidates");
                        history.push('/candidates');
                        return {
                            preventOverlayClose: false
                        };
                    },
                },
                items: []
            }] : []),
            ...(canViewReports() && isLookerReportsEnabled() ? [{
                title: "Reports",
                id: "Reports",
                clickable: {
                    type: "anchor",
                    anchorHref: "/reports",
                    anchorTarget: "_self",
                    onClick: (e) => {
                        e.preventDefault();
                        setSelectedItemId("Reports");
                        history.push('/reports');
                        return {
                            preventOverlayClose: false
                        };
                    },
                },
                items: []
            }] : []),
            ...(canManageSatisfaction() ? [{
                title: "Satisfaction",
                id: "Satisfaction",
                clickable: {
                    type: "anchor",
                    anchorHref: "/satisfaction",
                    anchorTarget: "_self",
                    onClick: (e) => {
                        e.preventDefault();
                        setSelectedItemId("Satisfaction");
                        history.push('/satisfaction');
                        return {
                            preventOverlayClose: false
                        };
                    },
                },
                items: []
            }] : []),
            ...(user?.userType === "INTERNAL_SUPPORT" ? [{
                title: "Data Sources",
                id: "Data Sources",
                clickable: {
                    type: "anchor",
                    anchorHref: "/datasources",
                    anchorTarget: "_self",
                    onClick: (e) => {
                        e.preventDefault();
                        setSelectedItemId("Data Sources");
                        history.push('/datasources');
                        return {
                            preventOverlayClose: false
                        };
                    },
                },
                items: []
            }] : []),
            {
                title: "Administrative",
                id: "Administrative",
                clickable: {
                    type: "button"
                },
                items: [
                    ...(canManageRules() ? [{
                        title: "Rules",
                        id: "Rules",
                        clickable: {
                            type: "anchor",
                            anchorHref: "/rules",
                            anchorTarget: "_self",
                            onClick: (e) => {
                                e.preventDefault();
                                setSelectedItemId("Administrative");
                                history.push('/rules');
                                return {
                                    preventOverlayClose: false
                                };
                            }
                        },
                        items: []
                    }] : []),
                    ...(canManageSurveys() ? [{
                        title: "Survey",
                        id: "Survey",
                        clickable: {
                            type: "anchor",
                            anchorHref: "/survey",
                            anchorTarget: "_self",
                            onClick: (e) => {
                                e.preventDefault();
                                setSelectedItemId("Administrative");
                                history.push('/survey');
                                return {
                                    preventOverlayClose: false
                                };
                            }
                        },
                        items: []
                    }] : []),
                    ...(canManageArticles() ? [{
                        title: "Library",
                        id: "Library",
                        clickable: {
                            type: "anchor",
                            anchorHref: "/library",
                            anchorTarget: "_self",
                            onClick: (e) => {
                                e.preventDefault();
                                setSelectedItemId("Administrative");
                                history.push('/library');
                                return {
                                    preventOverlayClose: false
                                };
                            }
                        },
                        items: []
                    }] : []),
                    ...(canManageUsers() && canBatchFeature() ? [{
                        title: "File Import",
                        id: "File Import",
                        clickable: {
                            type: "anchor",
                            anchorHref: "/file-import",
                            anchorTarget: "_self",
                            onClick: (e) => {
                                e.preventDefault();
                                setSelectedItemId("Administrative");
                                history.push('/file-import');
                                return {
                                    preventOverlayClose: false
                                };
                            }
                        },
                        items: []
                    }] : []),
                    ...(isPatientsEnabled() ? [{
                        title: "Providers",
                        id: "Providers",
                        clickable: {
                            type: "anchor",
                            anchorHref: "/providers",
                            anchorTarget: "_self",
                            onClick: (e) => {
                                e.preventDefault();
                                setSelectedItemId("Administrative");
                                history.push('/providers');
                                return {
                                    preventOverlayClose: false
                                };
                            }
                        },
                        items: []
                    }] : []),
                    ...(isPatientsEnabled() ? [{
                        title: "Services",
                        id: "Services",
                        clickable: {
                            type: "anchor",
                            anchorHref: "/services",
                            anchorTarget: "_self",
                            onClick: (e) => {
                                e.preventDefault();
                                setSelectedItemId("Administrative");
                                history.push('/services');
                                return {
                                    preventOverlayClose: false
                                };
                            }
                        },
                        items: []
                    }] : []), {
                        title: "Get Started",
                        id: "Get Started",
                        clickable: {
                            type: "anchor",
                            anchorHref: "/",
                            anchorTarget: "_self",
                            onClick: (e) => {
                                e.preventDefault();
                                setSelectedItemId("Administrative");
                                history.push('/');
                                return {
                                    preventOverlayClose: false
                                };
                            }
                        },
                        items: []
                    }]
            }
        ]
    };
};